import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, theme } from 'antd';
import { type ReactNode, useEffect, useState } from 'react';
import { type FoodGroup } from '../../../entities';
import FilterSelect from '../../../components/controls/filter-select';
import { useQuery } from '../../../jsonapi-provider';

export interface IngredientsFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters?: FiltersState;
}

interface FiltersState {
  query?: string;
  foodGroup?: number[];
}

const IngredientsFilter = (props: IngredientsFiltersProps): ReactNode => {
  const { initialFilters, onChange } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters ?? {});
  const { token } = theme.useToken();
  const foodGroups = useQuery<FoodGroup[]>([
    'food-group',
    { page: { limit: 10000 }, sort: 'name' },
  ]);

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS} flex={1} wrap="wrap">
      <Input
        allowClear
        value={filters?.query}
        placeholder="Search"
        prefix={<SearchOutlined />}
        onChange={(e) => {
          setFilter((prev) => ({
            ...prev,
            query: e.target?.value || undefined,
          }));
        }}
        style={{ maxWidth: 300, marginInlineEnd: token.marginMD }}
      />
      <FilterSelect
        value={filters?.foodGroup}
        canSelectAll
        mode="multiple"
        options={foodGroups.data}
        optionValueProp="id"
        optionLabelProp="name"
        title="FoodGroup"
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            foodGroup: value,
          }));
        }}
      />
    </Flex>
  );
};

IngredientsFilter.defaultProps = {
  onChange: (_filters: FiltersState) => {},
  initialFilters: {},
};

export default IngredientsFilter;
